import { configureStore } from '@reduxjs/toolkit'
import { useDispatch, TypedUseSelectorHook, useSelector } from 'react-redux'
import layout from './reducers/layout'
import authentication from './reducers/authentication'
import authorizationsGroups from './reducers/authorizationsGroups'
import users from './reducers/users'
import registration from './reducers/registration'
import fixations from './reducers/fixations'
import orderTracking from './reducers/orderTracking'
import financialExposures from './reducers/financialExposures'
import tollingAccounts from './reducers/tollingAccounts'
import invoices from './reducers/invoices'
import qualityCertification from './reducers/qualityCertification'
import metalQuotation from './reducers/metalQuotation'

export const store = configureStore({
  reducer: {
    layout,
    authentication,
    authorizationsGroups,
    users,
    registration,
    fixations,
    orderTracking,
    financialExposures,
    tollingAccounts,
    invoices,
    qualityCertification,
    metalQuotation,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
